var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewasofdate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.19266 4.03906C6.38215 4.03906 5.72852 4.6927 5.72852 5.50321C5.72852 6.31372 6.38215 6.96736 7.19266 6.96736C8.00317 6.96736 8.65681 6.31372 8.65681 5.50321C8.65681 4.6927 8.00317 4.03906 7.19266 4.03906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.3016 5.21484C12.8897 2.60029 10.1706 0.953125 7.19001 0.953125C4.20942 0.953125 1.49029 2.60029 0.0784365 5.21484C-0.0261455 5.39786 -0.0261455 5.60702 0.0784365 5.7639C1.49029 8.40459 4.20942 10.0518 7.19001 10.0518C10.1706 10.0518 12.8897 8.40459 14.3016 5.79004C14.4062 5.60702 14.4062 5.39786 14.3016 5.21484ZM7.19001 8.71834C5.41212 8.71834 3.97412 7.28033 3.97412 5.50244C3.97412 3.72455 5.41212 2.28655 7.19001 2.28655C8.96791 2.28655 10.4059 3.72455 10.4059 5.50244C10.4059 7.28033 8.96791 8.71834 7.19001 8.71834Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewasofdate);
export default __webpack_public_path__ + "static/media/Viewasofdate.d709c0ed073cf7e5bcdc2946fe97ada1.svg";
export { ForwardRef as ReactComponent };